import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "TV.svg",
  "use": "TV.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"TV.svg\"><path d=\"M8.01,44.0209v-26a4,4,0,0,1,4-4h40a4,4,0,0,1,4,4v26a4,4,0,0,1-4,4h-40A4,4,0,0,1,8.01,44.0209Zm4-1a1,1,0,0,0,1,1h38a1,1,0,0,0,1-1v-24a1,1,0,0,0-1-1h-38a1,1,0,0,0-1,1Zm8,9a2,2,0,0,1,2-2h20a2,2,0,1,1,0,4h-20A2,2,0,0,1,20.01,52.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol